import { Tooltip } from '@rematter/ui-web';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';

import { useTranslations } from '~/modules/brokerage/i18n/useTranslations';
import { BrokeredOrderValidationError } from '~/modules/brokerage/types/brokeredOrder';
import { StatusIndicator } from '~/shared/components/line-items';

export interface ValidationStatusCellProps {
  errors?: BrokeredOrderValidationError[];
  validationRan?: boolean;
}

export const ValidationStatusCell = ({
  errors,
  validationRan = false,
}: ValidationStatusCellProps) => {
  const t = useTranslations();
  const hasErrors = errors && errors.length > 0;

  if (hasErrors) {
    return (
      <Tooltip
        tip={
          <div className="flex flex-col gap-1">
            {errors.map((err, i) => (
              <span key={i}>
                {t.orders.validation.errors[
                  err.code as keyof typeof t.orders.validation.errors
                ] ?? err.code}
              </span>
            ))}
          </div>
        }
      >
        <StatusIndicator
          variant="failure"
          icon={<AlertTriangle className="size-4" />}
        />
      </Tooltip>
    );
  }

  if (validationRan) {
    return (
      <StatusIndicator
        variant="success"
        icon={<CheckCircle2 className="size-4" />}
      />
    );
  }

  return null;
};
